import { computed, toValue, watch, type MaybeRefOrGetter } from 'vue'
import useGet from '@/core/composables/api/useGet'
import type { LessonState, LessonSummary } from '../models/lesson'

export const useLessons = (options?: {
  state?: MaybeRefOrGetter<LessonState | undefined>
  lessonImpulseId?: MaybeRefOrGetter<string | undefined>
  teamId?: MaybeRefOrGetter<string | undefined>
}) => {
  const { data, status, load, reload } = useGet<ReadonlyArray<LessonSummary>>('lesson')

  const query = computed(() => {
    const state = options?.state ? toValue(options.state) : undefined
    const lessonImpulseId = options?.lessonImpulseId ? toValue(options.lessonImpulseId) : undefined
    const teamId = options?.teamId ? toValue(options.teamId) : undefined
    const next: { state?: LessonState; lessonImpulseId?: string; teamId?: string } = {}
    if (state) {
      next.state = state
    }
    if (lessonImpulseId) {
      next.lessonImpulseId = lessonImpulseId
    }
    if (teamId) {
      next.teamId = teamId
    }
    return next
  })

  const loadLessons = () => load({ query: query.value })
  const reloadLessons = () => reload({ query: query.value })

  watch(
    query,
    () => {
      loadLessons()
    },
    { immediate: true },
  )

  return {
    lessons: data,
    status,
    reload: reloadLessons,
  }
}
